
<template>
  <div class="animated fadeIn">
    <p>
      <!-- Exit -->
      초기 설정 후에는 언제든지 설정을 변경할 수 있습니다.
      <b-button class="float-right" variant="link" @click="$parent.$emit('status', false)">빠른 설정 종료</b-button>
    </p>
    <b-card-group>
      <!-- .slideInDown
      .slideInLeft
      .slideInRight
      .slideInUp
      .slideOutDown
      .slideOutLeft
      .slideOutRight
      .slideOutUp -->
      <b-card v-if="step == 1" class="slideInDown slideOutDown">
        <!-- 안내 및 설정 방법 -->
        <b-row>
          <b-col class="text-center">
            <h3>
              만나서 반가워요. 새 에이전트가 설치되었습니다!
            </h3>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="12" class="text-center">
            <b-card-group deck style="cursor:pointer">
              <b-card bg-variant="primary" @click="list">
                <b-card-text>
                  <strong>
                    다른 서버에 설정 복사
                  </strong>
                  <hr>
                  <p>다른 WSFinder 에이전트에 설정을 적용합니다</p>
                  <hr>
                  <p>
                    [에이전트 선택] -> [설정 탭] -> [다른 서버 설정 선택] -> [적용]
                  </p>
                </b-card-text>
              </b-card>
              <b-card bg-variant="success" @click="next()">
                <b-card-text>
                  <strong>
                    정책 설정
                  </strong>
                  <hr>
                  <p>빨리 설정하고 서버에 숨겨진 웹 셸 찾기</p>
                  <hr>
                  <p>Anti-Webshell 설정 시작하기 </p>
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 2" class="slideInLeft slideOutLeft">
        <h4>* 서버에서 사용하는 업로드 디렉토리 선택하세요</h4>
        <hr>
        <!-- {{scan_list}} -->
        <!-- 폴더 설정 설정 -->
        <folder-set
          :only_view="true"
          :show="dir.length"
          :item="dir"
          :scan_list="setting.scan_list"
          :white_path="setting.white_path"

          @path="(s) => $parent.$emit('get_path', s)"
          @remove="(type, s) => remove_select(type, s) && $parent.$emit('remove', type, s)"
          @clear="() => $parent.$emit('clear')"

          @add_white_list="add_white_list"
          @add_scan_list="add_scan_list"
          @white_path_one="white_path_one"

        >
        </folder-set>
      </b-card>

      <b-card v-if="step == 3" class="slideInLeft slideOutLeft">
        <!-- 점검 정책 설정해야 함 -->
        <b-row style="height:180px;">
          <b-col md="5" class="text-right">
            <center>
              <div :style="style('RoyalBlue')" style="position:relative;top:50px;left:+60px;" @click="rule_update('Regex')" >
                <span v-if="rule.indexOf('Regex') > -1">&#10003;</span>
                Regex
              </div>
              <div :style="style('crimson')" style="position:relative;top:-10px;" @click="rule_update('Hash')" >
                <span v-if="rule.indexOf('Hash') > -1">&#10003;</span>
                Hash
              </div>
              <div :style="style('skyblue')" style="position:relative;top:50px;left:-60px;" @click="rule_update('Url')" >
                <span v-if="rule.indexOf('Url') > -1">&#10003;</span>
                URL
              </div>
            </center>
          </b-col>
          <b-col>
            <p style="margin-top:18px; font-size:55px;">
              +
            </p>
          </b-col>

          <b-col md="5" class="text-left">

            <!-- @click="rule_update('Ssdeep')" -->
            <div :style="style('gold')">
              <span v-if="rule.indexOf('Ssdeep') > -1">&#10003;</span>
              SSDEEP
            </div>
            <!-- @click="rule_update('OB')" -->
            <div :style="style('orange')">
              <span v-if="rule.indexOf('OB') > -1">&#10003;</span>
              <small class="font-weight-bold">Obfuscation</small>
            </div>
            <p class="mt-3">
              * 빠른 설정은 옵션을 지원하지 않습니다.
              <br>
              추가 설정은 빠른 설정 후 상세 설정에서 설정할 수 있습니다.
              <!-- This case if detect, Need a check file -->
            </p>

          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col>
            * 원을 선택하거나 "다음" 버튼을 클릭합니다 (기본값 : [{{rule_text}}])
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 4" class="slideInLeft slideOutLeft">
        <!-- 백업 모드 및 백업 경로 -->
        <b-row class="text-center">
          <b-col>
            * 예약 점검 설정은 부가적 설정입니다
            탐지된 파일의 검역을 특정 경로로 설정할 수 있습니다.
            <br>
            <br>
            사이트 코드에 악의적인 패턴이 있는 경우 실제 파일을 분리하기 때문에 사이트에 문제가 있을 수 있습니다.
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="4">
            * 격리에 사용할 전체 경로를 입력해주세요
            <br>
            <span class="text-danger font-weight-bold">* 격리 폴더는 미리 설정되어 있어야 합니다</span>
          </b-col>
          <b-col md="8">
            <b-form-input v-model="isolation" placeholder="/etc/var/isolation or C:\\www\\isolation"></b-form-input>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 5" class="slideInLeft slideOutLeft">
        <b-row class="text-center">
          <b-col>
            * 예약 검사는 선택적 설정입니다
          </b-col>
        </b-row>
        <hr>
        <!-- 스케줄 설정 -->
        <b-row class="text-center">
          <b-col>
            검사 일정을 선택하십시오.
          </b-col>
          <b-col>
            <Schedule :now_schedule="schedule" @save="x => { this.schedule = x }"/>
          </b-col>
        </b-row>
      </b-card>
    </b-card-group>
    <!-- 스탭 공통 처리 부분 -->
    <hr v-if="step < all">
    <b-button v-if="step > 1" block size="sm" variant="info" @click="prev()"> 이전 </b-button>
    <b-button v-if="step < all"  block size="sm" variant="primary" @click="next()">다음 </b-button>
    <b-button v-else  block size="sm" variant="success" @click="modal_save = true">저장 </b-button>
    <hr>
    <b-row>
      <b-col>
        <center>{{step}} / {{all}}</center>
      </b-col>
    </b-row>
    <b-modal title="This setting Apply to agent(Anti-Webshell)"  class="modal-success btn-add" v-model="modal_save" @ok="apply" ok-variant="success" header-bg-variant="warning">
      설정을 적용할까요? ?
      <hr>
      설정을 한번 적용 후,
      <br>
      "점검" 탭에서 수동 점검을 바로 수행할 수 있습니다.
      <br>
      설정은 언제든지 변경할 수 있습니다
    </b-modal>
    <!-- 디버그 영역 -->
    <!-- {{}} -->
  </div>
</template>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
